// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.non-existent-account-button {
  text-transform: capitalize;
}

.login-action.login label.login-field {
    text-align: center;
    font-weight: normal;
    margin-bottom: 10px;
    display: block;
}`, "",{"version":3,"sources":["webpack://./src/components/Authentication/Participant/Login.css"],"names":[],"mappings":"AAAA;EACE,0BAA0B;AAC5B;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,mBAAmB;IACnB,cAAc;AAClB","sourcesContent":[".non-existent-account-button {\n  text-transform: capitalize;\n}\n\n.login-action.login label.login-field {\n    text-align: center;\n    font-weight: normal;\n    margin-bottom: 10px;\n    display: block;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
